import React from "react";
import AppLayout from "@/Layouts/AppLayout";
import { useTitle } from "@/Utilities/Hooks";

import { BlockButton, Subheader } from "@/Components/";
import OrganizationLayout from "@/Layouts/OrganizationLayout";
import LayoutIcon from "@/Components/LayoutIcon";
import { House, IconCogAndUser } from "@/Icons";
import { Link, usePage } from "@inertiajs/inertia-react";
import { Briefcase } from "react-feather";
import { ClientCard } from "@/Pages/Agency/Clients/Partials/ClientCard";

export default function Home() {
  useTitle("Admin");

  const organizations = usePage().props?.organizations?.data || [];
  const favoriteIds =
    usePage().props?.auth?.user?.data?.meta?.favorite_organizations || [];

  const favoriteOrganizations = organizations.filter((o) =>
    favoriteIds.includes(o.id),
  );

  return (
    <div className="flex flex-col items-stretch gap-4">
      <div className="my-4 flex flex-shrink-0 flex-row flex-wrap gap-4 md:flex-nowrap">
        <BlockButton
          title="Commercial licenses"
          text="Mange global accounts"
          href={route("admin.agencies")}
          bgcolor="bg-primary hover:bg-primary-dark"
        />
        <BlockButton
          title="Pricing"
          text="Go to pricing"
          href={null}
          bgcolor="bg-typo-inactive"
        />
        <BlockButton
          title="Super users"
          text="Manage super users"
          href={route("admin.users")}
          bgcolor="bg-primary hover:bg-primary-dark"
        />
      </div>

      <div className="flex flex-col gap-2">
        <Subheader margin="" className="mt-12">
          Your favorite global accounts
        </Subheader>
        {favoriteOrganizations.length > 0 && (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-4">
            {favoriteOrganizations.map((organization) => (
              <ClientCard
                key={organization.id}
                organization={organization}
                favoriteIds={favoriteIds}
              />
            ))}
          </div>
        )}
        {favoriteOrganizations.length === 0 && (
          <div className="mt-10 flex w-full flex-col items-center justify-center gap-1 p-4 text-center">
            <IconCogAndUser size={50} className="mb-4 text-typo-inactive" />
            <p className="font-bold">
              You have no favorite global accounts yet
            </p>
            <p className="mb-4 text-typo-inactive">
              To add a global account as favorite, head over to global accounts
              and mark your favorites
            </p>
            <Link href={route("admin.agencies")} className="btn-blue">
              Manage global accounts
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

Home.layout = (page) => {
  const user = page?.props?.auth?.user?.data;
  return (
    <AppLayout>
      <OrganizationLayout
        header={`Hello ${user.firstname}`}
        icon={
          <LayoutIcon>
            <House size={40} className="text-black" />
          </LayoutIcon>
        }
        byline="Here you can create new Global accounts, edit pricing and manage your super users."
      >
        {page}
      </OrganizationLayout>
    </AppLayout>
  );
};
